const metafield = {
  namespace: "__helium_intelligence__",
  tagKey: "tags",
  similarKey: "similar",
  complementaryKey: "complementary",
};

export const productDetailsQuery = `#graphql
query product($id: ID!) {
product(id: $id) {
title
description
handle
featuredImage {
  src
width
height
altText
}
}
}
`;

export const GetProductByIdQuery = `
  query getProductByHandle($handle: String!) {
    product(handle: $handle) {
      id
      handle
      title
      handle
      description
      images(first: 5) {
        edges {
          node {
            originalSrc
            altText
          }
        }
      }
      featuredImage{
        src
        width
        height
        altText
      }
      variants(first: 100) {
        edges {
          node {
            id
            title
            selectedOptions{
              name
              value
            }
            price {
              amount
              currencyCode
            }
            availableForSale
            sku
            image{
              url
              altText
              width
              height
            }
          }
        }
      }
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
    }
  }
`;
